export const setTypeUserInQuery = (typeUser: string) => {
    if(typeUser === 'user') {
        return '${setTypeUserInQuery(user.typeUser)}';
    }
    return ''
}